import { Button, Label, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutLoadTestListeners extends Layout {
    buttonButton1: Button;
    labelArInvoiceProcessingCache: Label;
    labelArInvoiceProcessingCacheMessages: Label;
    labelDatafusionLoadTenderExpressRemote: Label;
    labelDatafusionLoadTenderExpressRemoteMessages: Label;
    labelDispatchAvailableMove: Label;
    labelDispatchAvailableMoveMessages: Label;
    labelDispatchEnvironmentManagementMovements: Label;
    labelDispatchEnvironmentManagementMovementsMessages: Label;
    labelDispatchEquipMove: Label;
    labelDispatchEquipMoveMessages: Label;
    labelDispatchPartialShipmentPlanningManifests: Label;
    labelDispatchPartialShipmentPlanningManifestsMessages: Label;
    labelDispatchPartialShipmentPlanningOrders: Label;
    labelDispatchPartialShipmentPlanningOrdersMessages: Label;
    labelLibClientList: Label;
    labelLibClientListMessages: Label;
    labelPowerbrokerBrokerageMovements: Label;
    labelPowerbrokerBrokerageMovementsMessages: Label;
    labelSettlementDriverSettlementStateFederalTax: Label;
    labelSettlementDriverSettlementStateFederalTaxMessages: Label;
    labelSettlementOrderPayablesCache: Label;
    labelSettlementOrderPayablesCacheMessages: Label;
    labelSettlementPayeeCache: Label;
    labelSettlementPayeeCacheMessages: Label;
    labelSettlementVoidedPayablesDriverSettlement: Label;
    labelSettlementVoidedPayablesDriverSettlementMessages: Label;
    labelSettlementVoidedPayablesOrderPayables: Label;
    labelSettlementVoidedPayablesOrderPayablesMessages: Label;
    textboxArInvoiceProcessingCacheCount: Textbox;
    textboxDatafusionLoadTenderExpressRemoteCount: Textbox;
    textboxDispatchAvailableMoveCount: Textbox;
    textboxDispatchEnvironmentManagementMovementsCount: Textbox;
    textboxDispatchEquipMoveCount: Textbox;
    textboxDispatchPartialShipmentPlanningManifestsCount: Textbox;
    textboxDispatchPartialShipmentPlanningOrdersCount: Textbox;
    textboxLibClientListCount: Textbox;
    textboxPowerbrokerBrokerageMovementsCount: Textbox;
    textboxSettlementDriverSettlementStateFederalTaxCount: Textbox;
    textboxSettlementOrderPayablesCacheCount: Textbox;
    textboxSettlementPayeeCacheCount: Textbox;
    textboxSettlementVoidedPayablesDriverSettlementCount: Textbox;
    textboxSettlementVoidedPayablesOrderPayablesCount: Textbox;
}
